module.exports = __webpack_public_path__ + "img/92.a048d19.png";